<template>
    <div class="modal fade" :class="{ in: isShowModal, active: isShow}"
        tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" v-show="isShow">
        <div class="modal-bg" @click="onModalClose"></div>
        <div class="modal-dialog" style="width: 900px;">
            <div class="modal-content">
                <div class="common-modal-close" data-dismiss="modal" aria-label="Close" @click="onModalClose">
                    <img class="common-modal-close" src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/modal-close.jpg">
                </div>

                <div class="modal-body">
                    <video ref="video" id="videoPageObj" controls="" 
                        :src="videoUrl" style="width: 100%;">
                    </video>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "VideoModel",
    props: {
        isShow: {
            type: Boolean
        },
        videoUrl: {
            type: String
        }
    },
    data () {
        return {
            isShowModal: false
        }
    },
    methods: {
        onModalClose () {
            this.isShowModal = false
            setTimeout(()=> {
                this.$emit('onModalClose')
            }, 100)
            if (this.$refs.video) {
                this.$refs.video.pause()
                this.$refs.video.currentTime = 0
            }
        }
    },
    watch: {
        isShow (newValue) {
            setTimeout(()=> {
                this.isShowModal = newValue
                if (newValue && this.$refs.video) {
                    this.$refs.video.currentTime = 0
                    this.$refs.video.play()
                }
            }, 100)
        }
    }
}
</script>

<style lang="less" scoped>
.modal-body {
    padding: 20px;
}
.modal-dialog {
    top: 15%;
}
.coupon_rule_hd {
    font-size: 22px;
    color: #282b2c;
    margin-bottom: 20px;
}

.modal.active {
    display: block;
}

.modal-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
}
</style>